const baseUrl =
  process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_BASE_URL || '';

const apiKey = process.env.REACT_APP_CREATIVE_API_KEY || '';

export async function getActivePinCode() {
  try {
    const headers = { 'Content-Type': 'application/json' };
    if (apiKey) headers['X-API-Key'] = apiKey;

    const response = await fetch(`${baseUrl}/admin/pin-code/public`, {
      method: 'GET',
      headers,
    });

    if (!response.ok) {
      return {
        success: false,
        error: `Failed to load PIN code (${response.status}).`,
      };
    }

    const data = await response.json();
    return data?.pinCode
      ? { success: true, pinCode: String(data.pinCode) }
      : { success: false, error: 'Invalid PIN response from API.' };
  } catch (error) {
    return {
      success: false,
      error: error?.message || 'Network error while loading PIN code.',
    };
  }
}
